import can from '@/assets/icons/can.png'
import coupon from '@/assets/icons/coupon.png'
import milk from '@/assets/icons/milk.png'
import paper from '@/assets/icons/paper.png'
import pet from '@/assets/icons/pet.png'
import socks from '@/assets/icons/socks.png'

export const CONVEYOR_ITEMS = [
  { src: milk, alt: '우유' },
  { src: socks, alt: '양말' },
  { src: paper, alt: '종이' },
  { src: coupon, alt: '쿠폰' },
  { src: can, alt: '캔' },
  { src: pet, alt: '병' },
] as const
